export const FETCHING_DATA = 'FETCHING_DATA';
export const FETCHING_FAILED = 'FETCHING_FAILED';
export const FETCHING_SUCCESS = 'FETCHING_SUCCESS';
// etc
